import { memo } from "react";
import { useAppSelector } from "stores";
import store from "stores/interfaces";
import MediumListOfficialPlaylistTabs from "./MediumListOfficialPlaylistTabs";
import MediumListLibraryTabs from "./MediumListLibraryTabs";

const MediumListTabs = () => {
  const group = useAppSelector((state) => {
    return store.getAppState(state, "userMediumListGroup");
  });

  switch (group) {
    case "officialPlaylist":
      return <MediumListOfficialPlaylistTabs />;
    case "soundMaster":
      return null; // サウンドマスターはタブを表示しない
    case "library":
    default:
      return <MediumListLibraryTabs />;
  }
};

export default memo(MediumListTabs);
